import {
  base64ToJson,
  camelizeFromPascal
} from "./chunk-ZUUF2P4F.js";
import {
  __export
} from "./chunk-UICA3PK6.js";

// src/mappers.ts
var mappers_exports = {};
__export(mappers_exports, {
  getEntityRefsObject: () => getEntityRefsObject,
  getLayoutSchema: () => getLayoutSchema,
  getQuery: () => getQuery,
  getReference: () => getReference,
  getRefsObject: () => getRefsObject,
  getWidgetSchema: () => getWidgetSchema
});
import _ from "lodash";

// src/page/mappers.ts
import { getProperty } from "dot-prop";
var mapPage = (res) => {
  var _a;
  const page = {
    id: res.data.id,
    localizations: res.data.pageLocalizations || [],
    language: res.data.languageId,
    layout: [],
    metatags: getReference(
      { ...res.data.metaTags },
      getRefsObject(res.data.refs)
    ),
    path: res.data.path,
    theme: res.data.layout.themeId,
    title: res.data.title,
    fields: mapPageFields(((_a = res.data.dynamicEntity) == null ? void 0 : _a.columns) || []),
    image: getReference({ ...res.data.image }, getRefsObject(res.data.refs)),
    refs: getRefsObject(res.data.refs),
    views: {}
  };
  page.views = getReference(
    { ...res.data.views },
    getRefsObject(res.data.refs, page)
  );
  return {
    ...page,
    layout: getLayoutSchema(
      res.data.layout.schema,
      getRefsObject(res.data.layout.refs, page)
    )
  };
};
var mapPageFields = (columns) => {
  var _a;
  const fields = {};
  for (const column of columns) {
    if (column.data) {
      if (Array.isArray(column.data)) {
        fields[column.name] = column.data.map((item) => ({
          ...getReference(
            item.value,
            getEntityRefsObject(column.type, item == null ? void 0 : item.refs)
          ),
          columns: item.columns.length ? mapPageFields(item.columns) : null
        }));
      } else {
        if (column.data.value) {
          if (typeof column.data.value === "object") {
            if (Array.isArray(column.data.value)) {
              fields[column.name] = column.data.value.map(
                (item) => {
                  var _a2;
                  return getReference(
                    item,
                    getEntityRefsObject(column.type, (_a2 = column.data) == null ? void 0 : _a2.refs)
                  );
                }
              );
            } else {
              fields[column.name] = getReference(
                { ...column.data.value },
                getEntityRefsObject(column.type, (_a = column.data) == null ? void 0 : _a.refs)
              );
            }
          } else {
            if (column.data.refs && column.data.refs.length) {
              if (column.type === 20) {
                fields[column.name] = {
                  ...column.data.refs[0],
                  type: column.type
                };
              } else {
                fields[column.name] = column.data.refs[0];
              }
            } else {
              fields[column.name] = column.data.value;
            }
          }
        } else if (typeof column.data.value === "boolean") {
          fields[column.name] = column.data.value;
        }
      }
    }
  }
  return fields;
};
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
var mapPageFieldsByMappings = (field, mappings) => {
  var _a, _b, _c, _d;
  const data = [];
  for (const item of field) {
    const value = {};
    for (const mapping of mappings) {
      const path = mapping.path.split(".").map((name) => camelizeFromPascal(name)).join(".");
      const property = getProperty({ value: item }, path);
      if (property) {
        if (isJsonString(property) && ((_b = (_a = JSON.parse(property)) == null ? void 0 : _a.value) == null ? void 0 : _b.src)) {
          value[mapping.name] = {
            src: ((_d = (_c = JSON.parse(property).value) == null ? void 0 : _c.src) == null ? void 0 : _d.label) || ""
          };
        } else {
          value[mapping.name] = property;
        }
      }
    }
    data.push(value);
  }
  return data;
};
var mapPagePath = (res) => res.data;

// src/query/mappers.ts
import { getProperty as getProperty2 } from "dot-prop";
var getQueryReferenceValue = ({ type, ref }, refs) => {
  const refValues = [];
  const isDynamic = refs.find((ref2) => ref2.key === "files");
  if (isDynamic) {
    const values = refs.reduce(
      (prev, next) => ({ ...prev, [next.key]: next.values || [] }),
      {}
    );
    if (type === "string") {
      refValues.push(...values.strings);
    } else if (type === "link") {
      refValues.push(...values.links);
    } else if (type === "navigation") {
      refValues.push(...values.navigations);
    } else {
      refValues.push(...values.files);
    }
  } else {
    refValues.push(...refs);
  }
  if (ref) {
    const reference = refValues.find((item) => item.id === ref);
    if (reference) {
      const types = ["image", "file", "video", "link", "string"];
      if (types.includes(type)) {
        return reference.path;
      } else {
        return reference;
      }
    }
  }
  return null;
};
var getQueryReference = (tree, refs) => {
  if (tree) {
    if ("type" in tree && "ref" in tree) {
      tree = getQueryReferenceValue(tree, refs);
    } else {
      for (const key in tree) {
        const branch = tree[key];
        if (branch) {
          if (Array.isArray(branch)) {
            tree[key] = branch.map((leaf) => getQueryReference(leaf, refs));
          } else if (typeof branch === "object") {
            if ("type" in branch) {
              if (branch.type === "static") {
                tree[key] = branch.label;
              } else {
                if ("ref" in branch) {
                  tree[key] = getQueryReferenceValue(branch, refs);
                }
              }
            } else {
              tree[key] = getQueryReference(branch, refs);
            }
          } else {
            tree[key] = branch;
          }
        }
      }
    }
  }
  return tree;
};
var getQueryMapping = (data, mappings) => {
  const item = {};
  for (const mapping of mappings) {
    const property = getProperty2(data, mapping.path);
    const children = (mapping.children || []).map(({ path, ...rest }) => {
      const splitted = path.split(".");
      return {
        ...rest,
        path: splitted[splitted.length - 1]
      };
    });
    if (typeof property === "boolean") {
      item[mapping.name] = property;
    }
    if (property) {
      if (typeof property === "object") {
        if (Array.isArray(property)) {
          const data2 = [];
          const properties = property;
          for (const prop of properties) {
            const result = getQueryMapping(prop, children);
            data2.push(result);
          }
          item[mapping.name] = data2;
        } else {
          if (property["value"] && property["refs"]) {
            if (mapping.type === "schema" && property["layout"]) {
              const { layout = [], value = {}, refs = [] } = property;
              item[mapping.name] = {
                views: getReference({ ...value }, getRefsObject(refs)),
                layout: layout.map(
                  (component) => getReference({ ...component }, getRefsObject(refs))
                )
              };
            } else {
              const data2 = getQueryReference(
                property["value"],
                property["refs"]
              );
              item[mapping.name] = data2;
            }
          } else {
            if (children.length) {
              item[mapping.name] = getQueryMapping(property, children);
            } else {
              item[mapping.name] = property;
            }
          }
        }
      } else {
        if (mapping.type === "link") {
          item[mapping.name] = {
            href: property
          };
        } else {
          item[mapping.name] = property;
        }
      }
    }
  }
  return item;
};
var mapQuery = (query, mappings) => {
  if (!mappings || !mappings.length)
    return query;
  if (Array.isArray(query)) {
    const data = [];
    for (const item of query) {
      data.push(getQueryMapping(item, mappings));
    }
    return data;
  } else {
    return getQueryMapping(query, mappings);
  }
};
var mapCreateQuery = (payload) => ({
  parameters: null,
  columns: (payload.columns || []).map((column) => ({
    ...column,
    data: Array.isArray(column.data) ? column.data : { ...column.data, refs: column.data.refs || [] }
  }))
});
var mapUpdateQuery = (payload) => ({
  parameters: payload.parameters,
  columns: (payload.columns || []).map((column) => ({
    ...column,
    data: Array.isArray(column.data) ? column.data : { ...column.data, refs: column.data.refs || [] }
  }))
});
var mapDeleteQuery = (payload) => ({
  parameters: payload.parameters,
  columns: []
});

// src/mappers.ts
var getReferenceValue = ({ type, ref, mappings = [], parameters = [] }, refs) => {
  if (ref) {
    if (type === "link") {
      const link = refs.links[ref];
      if (link) {
        return link.href;
      }
    } else if (type === "navigation") {
      const menu = refs.navigations[ref];
      if (menu) {
        return menu;
      }
    } else if (type === "query") {
      if (parameters.length && refs.componentqueries) {
        const componentquery = (refs.componentqueries || []).find(
          (componentquery2) => {
            const decodedParams = base64ToJson(componentquery2.uniqueId);
            if (componentquery2.id === ref && _.isEqualWith(parameters, decodedParams)) {
              return componentquery2;
            }
            return void 0;
          }
        );
        if (componentquery) {
          return mapQuery(componentquery.data, mappings);
        }
      } else {
        const query = refs.queries[ref];
        if (query) {
          return mapQuery(query, mappings);
        }
      }
    } else if (type === "showcase") {
      const showcase = refs.showcases[ref];
      if (showcase) {
        return mapQuery(showcase, mappings);
      }
    } else if (type === "string") {
      const string = refs.strings[ref];
      if (string) {
        return string;
      }
    } else if (type === "page") {
      const field = refs.page[ref];
      if (field) {
        return field;
      }
    } else if (type === "field") {
      const field = refs.fields[ref];
      if (field) {
        if (field.type === 20) {
          if (field.values) {
            return mapQuery(field.values.data, mappings);
          }
        } else if (Array.isArray(field)) {
          return mapPageFieldsByMappings(field, mappings);
        }
        return field;
      }
    } else {
      const file = refs.files[ref];
      if (file) {
        return file.path;
      }
    }
  }
  return null;
};
var getReference = (tree, refs, widget) => {
  if (tree) {
    if ("type" in tree && "ref" in tree) {
      tree = getReferenceValue(tree, refs);
    } else {
      for (const key in tree) {
        const branch = tree[key];
        if (branch) {
          if (Array.isArray(branch)) {
            for (let index = 0; index <= branch.length; index++) {
              const leaf = branch[index];
              if (leaf) {
                if ("widgetId" in leaf) {
                  const mappedLeaf = getReference(leaf, refs);
                  let widgetSchema = getWidgetSchema(
                    leaf.id,
                    mappedLeaf.widgetId,
                    _.mergeWith(mappedLeaf.props, mappedLeaf.refs),
                    refs
                  );
                  widgetSchema = widgetSchema.filter(
                    (component) => component.name !== "hidden-area" ? component : !component.props.isHidden && component
                  );
                  const nodes = widgetSchema.map(
                    (component) => getReference(component, refs, leaf)
                  );
                  if (nodes) {
                    branch.splice(index, 1, ...nodes);
                  }
                } else if ("refs" in leaf && "props" in leaf) {
                  branch[index] = {
                    ...leaf,
                    props: _.mergeWith(
                      leaf.props,
                      leaf.refs,
                      (source, target) => {
                        if (Array.isArray(source) && !Array.isArray(target)) {
                          return { ...target };
                        }
                      }
                    )
                  };
                }
              }
            }
            tree[key] = branch.map((leaf) => getReference(leaf, refs, widget));
          } else if (typeof branch === "object") {
            if ("type" in branch) {
              if (branch.type === "static") {
                tree[key] = branch.label;
              } else if (branch.type === "widget" && widget) {
                tree[key] = (widget == null ? void 0 : widget.props[branch.ref]) || null;
              } else {
                if ("ref" in branch) {
                  tree[key] = getReferenceValue(branch, refs);
                }
              }
            } else {
              tree[key] = getReference(branch, refs, widget);
            }
          } else {
            tree[key] = branch;
          }
        }
      }
    }
  }
  return tree;
};
var getNavigations = (data) => {
  var _a, _b;
  const items = [];
  if (!data.children)
    return items;
  for (const item of data.children) {
    items.push({
      title: item.title,
      href: ((_a = item.page) == null ? void 0 : _a.path) || item.staticUrl,
      icon: item.icon,
      target: item.target,
      id: ((_b = item.page) == null ? void 0 : _b.id) || "",
      className: item.className,
      children: getNavigations(item)
    });
  }
  return items;
};
var getRefsObject = (data, page) => {
  const refs = {
    fields: {},
    files: {},
    navigations: {},
    links: {},
    queries: {},
    componentqueries: [],
    showcases: {},
    strings: {},
    widgets: {},
    page: {
      image: {},
      path: {},
      title: ""
    }
  };
  for (const ref of data) {
    if (ref.values) {
      if (ref.key === "files") {
        for (const file of ref.values) {
          refs.files[file.id] = {
            path: file.path,
            mimetype: file.mimeType,
            extension: file.extension,
            size: file.size
          };
        }
      } else if (ref.key === "links") {
        for (const link of ref.values) {
          refs.links[link.id] = {
            href: link.path,
            title: link.title
          };
        }
      } else if (ref.key === "navigations") {
        for (const menu of ref.values) {
          refs.navigations[menu.id] = getNavigations(menu);
        }
      } else if (ref.key === "strings") {
        for (const string of ref.values) {
          refs.strings[string.id] = string.title;
        }
      } else if (ref.key === "queries") {
        for (const query of ref.values) {
          refs.queries[query.id] = query.values.data;
        }
      } else if (ref.key === "componentqueries") {
        for (const componentquery of ref.values) {
          refs.componentqueries.push({
            ...componentquery.values,
            id: componentquery.id
          });
        }
      } else if (ref.key === "showcases") {
        for (const showcase of ref.values) {
          refs.showcases[showcase.id] = showcase.values.data;
        }
      } else if (ref.key === "widgets") {
        for (const widget of ref.values) {
          refs.widgets[widget.id] = widget.schema || [];
        }
      }
    }
  }
  if (page) {
    refs.page = {
      title: page.title,
      path: {
        href: page.path,
        children: page.title
      },
      image: page.image
    };
    refs.fields = page.fields || {};
  }
  return refs;
};
var getEntityRefsObject = (type, data) => {
  if (type === 17 /* Dynamic */) {
    return getRefsObject(data);
  } else {
    if (type === 6 /* Link */) {
      return getRefsObject([{ key: "links", values: data }]);
    } else {
      return getRefsObject([{ key: "files", values: data }]);
    }
  }
};
var getLayoutSchema = (schema, refs) => {
  const result = [];
  for (const component of schema) {
    const reference = getReference({ components: [component] }, refs);
    if ("components" in reference) {
      result.push(...reference.components);
    }
  }
  return result;
};
var getWidgetSchema = (nodeId, widgetId, props, refs) => {
  const nodes = [];
  const schema = _.cloneDeep(refs.widgets[widgetId] || []);
  for (const node of schema) {
    const current = { ...node };
    for (const id in current.refs) {
      const prop = current.refs[id];
      if (typeof prop !== "string" && prop && "type" in prop && "ref" in prop) {
        if (prop.type === "widget" && props[prop.ref]) {
          current.props[id] = props[prop.ref];
          current.refs[id] = props[prop.ref];
        }
      }
    }
    current.id = `${nodeId}-${current.id}`;
    nodes.push(current);
  }
  return nodes;
};
var getQuery = mapQuery;

export {
  mapPage,
  mapPagePath,
  mapQuery,
  mapCreateQuery,
  mapUpdateQuery,
  mapDeleteQuery,
  getReference,
  getRefsObject,
  getEntityRefsObject,
  getLayoutSchema,
  getWidgetSchema,
  getQuery,
  mappers_exports
};
